export const RESPONSIVE_CARD_IMAGE_LEFT = "col-8 col-lg-4 order-lg-2";
export const RESPONSIVE_CARD_IMAGE_RIGHT = "col-8 col-lg-4 order-lg-1";
export const RESPONSIVE_CARD_TEXT_LEFT = "col-12 col-lg-8 card-texts order-1";
export const RESPONSIVE_CARD_TEXT_RIGHT = "col-12 col-lg-8 card-texts order-2";
